module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/horn-5c40be4e1990447eec9bbbb5342e7f67.png";